import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver';
import { DicomMicroscopyPath } from './DicomMicroscopyRenderPath';
export function createDefaultWSIRenderPaths() {
    return [new DicomMicroscopyPath()];
}
export function createWSIRenderPathResolver(paths = createDefaultWSIRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
